import { Component, ComponentFactoryResolver, ComponentRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild, inject, DestroyRef } from '@angular/core';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { UrlService } from 'src/app/services/util/url.service';
import { DeployStatus } from 'src/app/models/deploy/deploy-status';
import { ClipboardService } from 'ngx-clipboard';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';
import { InstancesService } from 'src/app/services/api/instances.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import cloneDeep from 'lodash/cloneDeep';
import { translate } from '@jsverse/transloco';
import { Constants } from 'src/app/models/constants';
import { ColumnFilterComponent } from 'src/app/main/instances-mgmt/column-filter/column-filter.component';
import { ToastrErrorService } from 'src/app/services/util/toastr-error.service';
import { ChangeDetectorRef } from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import { DateTimeFormatService } from 'src/app/services/util/date-time-format.service';
import { DatePipe } from '@angular/common'
import { PermissionsService } from 'src/app/services/util/permissions.service';
import { Permissions, Datazone, Attributes } from 'src/app/models/principal/permission';
import { CustomTooltipComponent } from 'src/app/main/custom-tooltip/custom-tooltip.component';
import { PopupHostDirective } from 'src/app/directives/host.directive';
import { SolutionsService } from 'src/app/services/api/solutions.service';
import { TenantService } from 'src/app/services/api/tenant.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subscription, combineLatest, finalize, forkJoin, map, mergeMap, of } from 'rxjs';
import { BreadcrumbItem } from 'src/app/models/breadcrumb/breadcrumb-item';
import { RouterSegments } from 'src/app/models/router-segments';
import { ErrorPageService } from 'src/app/services/util/error-page.service';
import { BlueprintsService } from 'src/app/services/api/blueprints.service';
import { Blueprint, InstanceTabs } from 'src/app/models/blueprints/blueprint';
import { Instance } from 'src/app/models/instance/instance';
import { Configuration } from 'src/app/models/configurations/configuration';
import { DeploymentClass } from 'src/app/models/instance-class';
import { Sort, SortDirection } from 'src/app/models/sort';
import { KeyValueMap } from 'src/app/models/key-value-map';
import { CRVTService } from 'src/app/services/api/crvt.service';
import { PaginatorComponent } from 'src/app/components/paginator/paginator.component';
import { DataZone } from 'src/app/models/data-zone/data-zone';
import { PermissionKeys } from 'src/app/models/principal/permission-keys';
import { TimeDurationPipe } from 'src/app/pipes/timeDuration.pipe';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { DurationPipe } from 'src/app/pipes/duration.pipe';
import { DbBackupFormComponent } from 'src/app/components/instance-details/db-backup-form/db-backup-form.component';
import { DatabaseBackupComponent } from 'src/app/components/database-backup/database-backup.component';
import { BackupService } from 'src/app/services/api/backup.service';
import moment from 'moment';
import { FeatureKeys } from 'src/app/models/feature/feature-keys';
import { Feature, FeatureAttributes, FeatureDatazone } from 'src/app/models/feature/feature';
import { FeaturePermissionsService } from 'src/app/services/util/feature-permissions.service';
import { DbBackupDetailsComponent } from 'src/app/components/instance-details/db-backup-details/db-backup-details.component';
import { DbbackupService } from 'src/app/services/api/dbbackup.service';
import { CloudProvider } from 'src/app/models/cloud-provider/cloud-provider';
import { EnvScheduleService } from 'src/app/services/api/env-schedule.service';
import { EnvironmentTableComponent } from '../environment-table/environment-table.component';
import { EnvironmentPaginatorComponent } from '../environment-paginator/environment-paginator.component';
import { AvailabilityStatus } from 'src/app/models/availability-status';

type ComparatorFunc = (first: any, second: any) => number;


const REQUIRED_FEATURES = [
  {
    key: FeatureKeys.DATABASE_SNAPSHOT_NONPII,
    name: Feature.DATABASE_SNAPSHOT,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.NONPII
  },
  {
    key: FeatureKeys.DATABASE_SNAPSHOT_PII,
    name: Feature.DATABASE_SNAPSHOT,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.PII
  },
  {
    key: FeatureKeys.DATABASE_SNAPSHOT_LIVE,
    name: Feature.DATABASE_SNAPSHOT,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.LIVE
  },
  {
    key: FeatureKeys.DATABASE_ARCHIVE_LIVE,
    name: Feature.DATABASE_ARCHIVE,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.LIVE
  }
];

@Component({
  selector: 'app-environment-database-backup-component',
  templateUrl: './environment-database-backup-component.html',
  styleUrl: './environment-database-backup-component.scss',
  standalone: false,
    providers: [
        TimeDurationPipe,
        DurationPipe,
    ],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
})

export class EnvironmentDatabaseBackupComponent  implements OnInit {
  @ViewChild(EnvironmentPaginatorComponent) paginatorRef: EnvironmentPaginatorComponent;
  @ViewChild(EnvironmentTableComponent) tableRef: EnvironmentTableComponent;
  @ViewChild(PaginatorComponent, { static: true }) paginator: PaginatorComponent;
  @Input() data: any;
  @Input() instanceName: any;
  @Output() updateInstnace = new EventEmitter();
  private destroyRef = inject(DestroyRef);
  currentElement: any;
  Constants = Constants;
  permissionsMap: { [key: string]: boolean };
  DeployStatus = DeployStatus;
  copy = false;
  paginationSize = 10;
  currentEnvironment: any;
  pageIndex = 0;
  sortInfo: any;
  filteredColumns: any;

  direction: any;
  status: any;
  dropdownsList: any;
  clearData: boolean;
  showSpinner: boolean;
  isFailed: boolean;
  activeTab: number = 0;
  RouterSegments = RouterSegments;
  InstanceTabs = InstanceTabs;
  breadcrumbItems: BreadcrumbItem[];
  tenant: string;
  blueprint: Blueprint;
  instance: Instance;
  isOverview = true;
  isEndpoints = false;
  isAMR: boolean;
  DataZone = DataZone;

  configurationsMap: KeyValueMap<string, Configuration>;
  searchTerm: string = '';

  SortDirection = SortDirection;
  sort: Sort;

  allInstances: any;
  selectedFilter: any =  {
    label: 'All',
    value: ''
  };

  releaseManager = false;
  DeploymentClass = DeploymentClass;

  loaderStatus = [
    DeployStatus.DEPLOYING,
    DeployStatus.TERMINATING,
    DeployStatus.CONFIGURING,
    DeployStatus.UPDATING,
    DeployStatus.OPERATION_INPROGRESS
  ];

  filterStartDate: any;
  filterEndDate: any;
  type: any;
  permissions = Permissions;
  PermissionKeys = PermissionKeys;
  instanceId: any;
  backupTable: any = [];
  backupTableColumns = ['databaseName', 'applicationStartTime', 'expiryDays', 'pitrTimestamp', 'ticketNumber', 'initiatedBy', 'status', 'delete'];
  isBackupTableLoaded: boolean;
  backupResults: any = [];
  searchText: string;
  dbFilterRecord: any;
  databases: any;
  routes: any = [];
  keys: any = [];
  AvailabilityStatus = AvailabilityStatus;
  dbStatusFilter = [
    {
      name: 'Completed',
      value: 'completed',
      selected: false
    },
    {
      name: 'Expired',
      value: 'expired',
      selected: false
    },
    {
      name: 'In progress',
      value: 'inprogress',
      selected: false
    },
    {
      name: 'failed',
      value: 'failed',
      selected: false
    },
    {
      name: 'deleted',
      value: 'deleted',
      selected: false
    },
    {
      name: 'deleting',
      value: 'deleting',
      selected: false
    },
    {
      name: 'delete failed',
      value: 'delete_failed',
      selected: false
    }
  ]

  dbTypeFilter = [
    {
      name: 'Snapshot',
      value: 'snapshot',
      selected: false
    },
    {
      name: 'Archive',
      value: 'archive',
      selected: false
    }
  ]

  dbNameFilter = [
    {
      name: 'Month End',
      value: 'monthEnd',
      selected: false
    },
    {
      name: 'Year End',
      value: 'yearEnd',
      selected: false
    },
    {
      name: 'Adhoc',
      value: 'adhoc',
      selected: false
    }
  ]
  dbFilter: any;
  apiNotFound = false;
  dbType: any;
  dbName: any;
  createdDate: any;
  //dbStatus: any;
  scheduleName: any;


  readonly DR_STATES = [DeployStatus.FAILOVER_APPLYING, DeployStatus.FAILBACK_APPLYING,
    DeployStatus.PRE_FAILBACK_APPLYING, DeployStatus.FAILOVER_FAILED, DeployStatus.FAILBACK_FAILED, DeployStatus.PRE_FAILBACK_FAILED, DeployStatus.POST_FAILBACK_APPLYING, DeployStatus.POST_FAILBACK_FAILED];

  readonly INSTANCE_AVAILABLE_STATUS = [DeployStatus.DEPLOYED, DeployStatus.UPDATED,
    DeployStatus.UPDATE_FAILED, DeployStatus.TESTED, DeployStatus.TEST_FAILED,
    DeployStatus.CONFIGURED, DeployStatus.CONFIGURATION_FAILED,
    DeployStatus.FAILED, DeployStatus.FAILOVER_FAILED, DeployStatus.FAILBACK_FAILED, DeployStatus.PRE_FAILBACK_FAILED, DeployStatus.POST_FAILBACK_FAILED, DeployStatus.STOP_FAILED];

  readonly INSTANCE_DEPLOYING_STATES = [DeployStatus.DEPLOYING, DeployStatus.TERMINATED, DeployStatus.TERMINATION_FAILED,
    DeployStatus.CONFIGURING, DeployStatus.UPDATING, DeployStatus.OPERATION_INPROGRESS,
    DeployStatus.FAILOVER_APPLYING, DeployStatus.FAILBACK_APPLYING, DeployStatus.INITIALIZING,
    DeployStatus.PRE_FAILBACK_APPLYING, DeployStatus.POST_FAILBACK_APPLYING, DeployStatus.TERMINATING, DeployStatus.TESTING, DeployStatus.STARTING, DeployStatus.STOPPING, DeployStatus.INPROGRESS];

  dbDropdownsList:any;
  dbStatus: any;
  showLoader = false;
  dataSourceDb: any;
  dbPaginator: any;
  dbPaginationSize = 10;
  dbInprogess = false;
  dbError: any;
  dbFilterTags: any;
  date: any;
  searchedResult = [];
  FeatureKeys = FeatureKeys;
  featuresMap: { [key: string]: boolean };
  components: boolean;
  filteredIsManagedColumns:any;
  selectedIsManaged: any;
  selectedVersion:any[];
  hasSecondaryRegion: any;
  isAWS: boolean;
  service: any;
  envDBResponse = false;
  dbLoading = true;
  isRefreshing = false;
  isFiltered = false;
  selectedStatus = [];
  selectedDBName = [];
  selectedDBType = [];
  dbdata:any;
  runbookType: any;


 displayColumns = [
    {
      key: 'dbName',
      name: 'INSTANCE_DETAILS.NAME',
      type: 'dbName',
      sortable: true,
      visible: true,
      disable: true,
      keyLink: 'navigation'
    },
    {
      key: 'createdAt',
      name: 'INSTANCE_DETAILS.CREATED_DATE_UTC',
      type: 'date',
      visible: true,
      disable: false,
      sortable: true
    },
    {
      key: 'expirationDate',
      name: 'INSTANCE_DETAILS.RETENTION_DATE_UTC',
      type: 'date',
      visible: true,
      disable: false,
      sortable: true
    },
    {
      key: 'pitrTimestamp',
      name:  'INSTANCE_DETAILS.SNAPSHOT_DATE_TIME',
      type: 'date',
      visible: true,
      disable: false,
      sortable: true
    },
    {
      key: 'ticketNumber',
      name:  'INSTANCE_DETAILS.JIRA_TICKET',
      type: 'text',
      visible: true,
      disable: true,
      sortable: false,
      keyLink: 'navigation'
    },
    {
      key: 'user',
      name:  'INSTANCE_DETAILS.MODIFIED_BY_DB',
      type: 'user',
      visible: true,
      disable: true,
      sortable: false
    },
    {
      key: 'status',
      name:  'INSTANCE_DETAILS.STATUS',
      type: 'status',
      visible: true,
      disable: true,
      sortable: false
    },
    {
      key: 'action',
      name: 'SCHEDULE.ACTIONS',
      type: 'dbAction',
      visible: true,
      disable: true
    },
    {
      key: 'runbookSettings',
      name: '',
      type: 'settings',
      visible: true,
      disable: true
    }
  ];
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private errorPageService: ErrorPageService,
    private changeDetectorRef: ChangeDetectorRef,
    public urlService: UrlService, private toastrService: CustomToastrService, private clipboardApi: ClipboardService,public dateTimeFormatService: DateTimeFormatService,
     private instanceService: InstancesService, private sidenavService: SidenavService, private tenantService: TenantService,
      private dialog: MatDialog, private toastrErrorService: ToastrErrorService, private cdr: ChangeDetectorRef,
      public datePipe: DatePipe, private route: ActivatedRoute,
      private formBuilder: FormBuilder, private backupService: BackupService,
      private featurePermissionsService: FeaturePermissionsService,private dbBackupService: DbbackupService) {

   }

  ngOnInit(): void {
  this.instanceId = this.route.snapshot.params.instanceId;
  this.instance = this.data;
  this.tenantService.tenantData$.subscribe((data: any) => {
      this.isAWS = data === CloudProvider.AWS ? true : false;
    });
    this.paginator?.page
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(pageEvent => {
      this.applyPaginator();
    });
    this.featuresMap = this.featurePermissionsService.resolveFeaturePermissions(REQUIRED_FEATURES);
      this.dbDropdownsList = [
        {
          title: 'Status',
          placeholder: 'Select Status',
          options: this.dbStatusFilter
        },
        {
          title: 'DB Type',
          placeholder: 'Select DB Type',
          options: this.dbTypeFilter
        },
        {
          title: 'Name',
          placeholder: 'Select Name',
          options: this.dbNameFilter
        }
      ];
  if (localStorage.getItem('filteredDBType')) {
      const userData = JSON.parse(localStorage.getItem('filteredDBType'));
      if (userData) {
        this.selectedDBType = userData;
        this.runbookType = this.selectedDBType;
        this.dropdownsList?.[0]?.options?.forEach(element => {
          if(this.selectedDBType.find(item=> item === element.value)) {
            element.selected = true;
          }
        });
      }
    }
    if (localStorage.getItem('filteredDBStatus')) {
      const userData = JSON.parse(localStorage.getItem('filteredDBStatus'));
      if (userData) {
        this.selectedStatus = userData;
        this.runbookType = this.selectedStatus;
        this.dropdownsList?.[1]?.options?.forEach(element => {
          if(this.selectedStatus.find(item=> item === element.value)) {
            element.selected = true;
          }
        });
      }
    }
    if (localStorage.getItem('filteredDBName')) {
      const userData = JSON.parse(localStorage.getItem('filteredDBName'));
      if (userData) {
        this.selectedDBName = userData;
        this.runbookType = this.selectedDBName;
        this.dropdownsList?.[2]?.options?.forEach(element => {
          if(this.selectedDBName.find(item=> item === element.value)) {
            element.selected = true;
          }
        });
      }
    }
    this.getDatabases();
    this.resetJobFilter();
    this.clearData = true;
    this.initialLoad();
 }

  ngAfterViewChecked(){
    this.cdr.detectChanges();
 }

 initialLoad(): void {
    this.isFailed = false;
  }

 refreshClick(): void {
  this.isRefreshing = true;
  this.dbLoading = true;
  if (this.isFiltered) {
  setTimeout(() => {
    this.isRefreshing = false;
    this.dbLoading = false;
  }, 1000);
  return;
}
  if (this.paginatorRef) {
    this.paginatorRef.pageIndex = 0;
  }

  this.getDatabases();

  setTimeout(() => {
    this.isRefreshing = false;
    this.dbLoading = false;
  }, 1000);
}

  resetPaginator() {
     this.pageIndex = 0;
     this.paginatorRef.pageIndex = 0;
  }

   onPageChange(event) {
    this.paginationSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.tableRef?.pageChanged(event);
   }

  onTablePageChanged(event) {
    this.pageIndex = event.pageIndex;
    this.paginationSize = event.pageSize;
  }

  sortDbData(event): void {
    this.backupTable = this.sortDbInstanceData(event);
    this.pageIndex = 0;
    const data = this.backupTable?.slice(0, 0 + this.dbPaginationSize);
    this.dataSourceDb = new MatTableDataSource(data);
  }

  sortDbInstanceData(event): void {
    return this.backupTable?.sort((a, b) => {
      let comparatorResult = 0;
      switch (event.active) {
        case 'applicationStartTime':
          comparatorResult = new Date(a?.applicationStartTime)?.getTime() < new Date(b?.applicationStartTime)?.getTime() ? -1 : 1;
          break;
        case 'expiryDays':
          comparatorResult = new Date(a?.expiryDate)?.getTime() < new Date(b?.expiryDate)?.getTime() ? -1 : 1;
          break;
        case 'pitrTimestamp':
          comparatorResult = new Date(a?.pitrTimestamp)?.getTime() < new Date(b?.pitrTimestamp)?.getTime() ? -1 : 1;
          break;
      }
      return comparatorResult * (event.direction === 'asc' ? 1 : -1);
     });
  }

  dbPageChanged(event): any {
    if (event.length) {
      this.pageIndex = event.pageIndex;
      this.dbPaginationSize = event.pageSize;
      const firstIndex = this.pageIndex * this.dbPaginationSize;
      const data = this.backupTable?.slice(firstIndex, firstIndex + this.dbPaginationSize);
      this.dataSourceDb = new MatTableDataSource(data);
    }
  }

  closeDbMenu(data): void {
    this.sidenavService.searchFilter.next(data);
    this.filteredDbColumnsFunction(data);
  }

  dbFilterColumns(): void {
    if (this.dbStatus?.length === 0) {
      this.resetAllDbValues();
    } else {
      this.resetDbValue(this.dbStatus);
    }
    if(this.dbStatus) {
      this.dbDropdownsList[0].options.filter((item) => {
        if (item.value === this.status) {
          item.selected = true;
        }
      });
    } else {
      this.dbDropdownsList[0].options.filter((item) => {
        item.selected = false;
      });
    }
    const data: any = {
      name: translate('INSTANCE_STATUS.DB'),
      title: translate('INSTANCE_STATUS.FILTER_TITLE'),
      subtitle: translate('INSTANCE_STATUS.FILTER_SUBTITLE'),
      isMultiSelect: true,
      filteredColumns: this.dbDropdownsList,
      status: this.dbDropdownsList[0].options,
    };
      data.dbType = this.dbDropdownsList[1].options,
      data.dbName = this.dbDropdownsList[2].options
      data.dbColumns = [
        'status',
        'dbType',
        'dbName'
      ]
     this.sidenavService.openInRightSidenav(ColumnFilterComponent, data)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(filteredColumns => {
          if (filteredColumns) {
            this.clearData = true;
            if(filteredColumns[0] !== '') {
              this.dbStatus = filteredColumns[0];
            }
            const filters = [...this.dbDropdownsList[0]?.options, ...this.dbDropdownsList[1]?.options, ...this.dbDropdownsList[2]?.options]
            this.applyFilter(filters);
          }
        });
  }

  filteredDbColumnsFunction(data): void {
    this.dbStatus.forEach(element => {
      if(element === this.dbFilterRecord.find(filter => filter.name === data)?.value){
      this.dbStatus = this.dbStatus.filter(item => item !== element);
      if(this.dbStatus.length > 0){
        this.resetDbValue(this.dbStatus);
      }else{
        this.dbStatus = undefined;
        this.resetAllDbValues();
      }
      }
    });
      this.applyFilter(this.dbFilter);
  }

  resetDbFilter(): void {
    this.dbStatus = undefined;
    this.clearData = false;
    this.sidenavService.searchFilter.next('data');
    this.resetAllDbValues();
    this.applyFilter(this.dbDropdownsList);
  }

   search(searchTerm?: string): void {
    this.searchTerm = searchTerm;
  }

   searchedItems(result): void {
    this.searchedResult = result;
    this.cdr.detectChanges();
  }

  resetAllDbValues(): void {
    this.dbDropdownsList.forEach(element => {
     element?.options?.forEach(item => {
       item.selected = false;
     });
   });
   this.dbFilter.forEach(element => {
    element.selected = false;
  });
  this.dbFilterRecord.forEach(element => {
    element.selected = false;
  });
 }

 resetDbValue(data): void {
    this.dbDropdownsList.forEach(element => {
    element?.options?.forEach(item => {
      item.selected = false;
    });
  });
  this.dbFilter.forEach(element => {
    if(data?.includes(element.value)){
      element.selected = true;
    }else{
      element.selected = false;
    }
  });
  this.dbFilterRecord.forEach(element => {
    element.selected = false;
  });
  }

  resetValue(closedItem): void {
    closedItem?.options?.forEach(element => {
      element.selected = false;
    });
    this.dbFilter.forEach(element => {
      element.selected = false;
    });
    this.dbFilterRecord.forEach(element => {
      element.selected = false;
    });
  }

  resetAllValues(): void {
     this.dropdownsList.forEach(element => {
      element?.options?.forEach(item => {
        item.selected = false;
      });
    });
  }

  openUrl(): void {
    const url = `${this.currentEnvironment}${this.data?.tenantId}/services/${this.data?.solutionId}/blueprints/${this.data?.blueprintId}`;
    window.open(url, '_blank');
  }

  onCopyId(data): void {
    this.copy = true;
    this.clipboardApi.copyFromContent(data);
    setTimeout(() => {
      this.copy = false;
    }, 500);
  }

  // Shows configuration states according to page selection
  private applyPaginator(): void {
    const startIndex = this.paginator.pageIndex * this.paginator.pageSize;
    this.changeDetectorRef.detectChanges();
  }


  ngOnDestroy(): void {
    setTimeout(() => {
      if (document.getElementsByClassName("cdk-overlay-container")) {
        const element = <HTMLElement> document.getElementsByClassName("cdk-overlay-container")[0];
        if (element) {
          element.style.display = 'block';
        }
      }
    }, 100);
  }

  applyFilter(data): void {
    this.dbFilter = data;
    const selectedFilters = this.dbFilter.filter(item => item.selected === true).map(item => item.value);
    selectedFilters.forEach(filter => {
      this.dbFilterRecord.find(item => item.value === filter).selected = true;
    })
    let filteredResults = [];
    if (selectedFilters?.length > 0) {
      const isStatus = this.dbStatusFilter.filter(item => item.selected === true);
      const isType = this.dbTypeFilter.filter(item => item.selected === true);
      const isName = this.dbNameFilter.filter(item => item.selected === true);

     const filteredStatusResults = this.backupResults.filter(item => (selectedFilters.includes(item.status)) || (selectedFilters.includes('expired') && item.isExpired));
     const filteredTypeResults = this.backupResults.filter(item => (selectedFilters.includes(item.backupType)));
     const filteredNameResults = this.backupResults.filter(item => (selectedFilters.includes(item?.backupInterval)));
     if(isStatus?.length > 0 && isType?.length > 0 && isName?.length > 0){
     if(filteredStatusResults?.length > 0 && filteredTypeResults?.length > 0 && filteredNameResults?.length > 0){
        filteredResults = this.backupResults.filter(item =>
        {
          (((selectedFilters.includes(item?.status) || (selectedFilters.includes('expired') && item.isExpired)) && selectedFilters.includes(item?.backupType)) && selectedFilters.includes(item?.backupInterval)) || selectedFilters.includes('')
        }
        );
      }
    }
    if(isStatus?.length > 0 && isType?.length > 0 && isName?.length > 0){
      if(filteredStatusResults?.length > 0 && filteredTypeResults?.length > 0 && filteredNameResults?.length > 0){
         filteredResults = this.backupResults.filter(item =>
           (selectedFilters.includes(item?.backupType) && selectedFilters.includes(item?.backupInterval)) || selectedFilters.includes('')
         );
         filteredResults = filteredResults.filter(item =>
          (selectedFilters.includes(item?.status) || (selectedFilters.includes('expired') && item.isExpired)) || selectedFilters.includes('')
        );
       }
     }
     else if(isStatus?.length > 0 && isName?.length > 0){
      if(filteredStatusResults?.length > 0 && filteredNameResults?.length > 0){
         filteredResults = this.backupResults.filter(item =>
           ((selectedFilters.includes(item?.status) || (selectedFilters.includes('expired') && item.isExpired)) && selectedFilters.includes(item?.backupInterval)) || selectedFilters.includes('')
         );
       }
     }
     else if(isType?.length > 0 && isName?.length > 0){
      if(filteredTypeResults?.length > 0 && filteredNameResults?.length > 0){
         filteredResults = this.backupResults.filter(item =>
           (selectedFilters.includes(item?.backupType) && selectedFilters.includes(item?.backupInterval)) || selectedFilters.includes('')
         );
       }
     }
     else if(isType?.length > 0 && isStatus?.length > 0){
      if(filteredTypeResults?.length > 0 && filteredStatusResults?.length > 0){
         filteredResults = this.backupResults.filter(item =>
           (selectedFilters.includes(item?.backupType) && (selectedFilters.includes(item?.status) || (selectedFilters.includes('expired') && item.isExpired))) || selectedFilters.includes('')
         );
       }
     }
     else{
      filteredResults = this.backupResults.filter(item => ((selectedFilters.includes(item?.status) || (selectedFilters.includes('expired') && item.isExpired)) || selectedFilters.includes(item?.backupType) || selectedFilters.includes(item?.backupInterval)) || selectedFilters.includes(''));
     }
    } else {
      filteredResults = this.backupResults;
    }
    this.dbStatus = selectedFilters;
    this.dbFilterTags = [];
    selectedFilters.forEach(item => {
      this.dbFilterTags = [...this.dbFilterTags, this.dbFilterRecord.find(filter => filter.value === item)?.name];
    })
    if(selectedFilters[0] === ''){
      this.dbStatus = [this.dbStatusFilter[0].name];
    }
    if (this.searchText) {
      filteredResults = filteredResults.filter(item => item.to?.databaseName?.toLowerCase().includes(this.searchText) || item.to?.fileName?.toLowerCase().includes(this.searchText) || item.to?.serverName?.toLowerCase().includes(this.searchText) ||
      item.component?.toLowerCase().includes(this.searchText) || item.ticketNumber?.toLowerCase().includes(this.searchText));
    }
    this.pageIndex = 0;
    const tableData = filteredResults?.slice(0, 0 + this.dbPaginationSize);
    this.backupTable = filteredResults;
    this.dataSourceDb = new MatTableDataSource(tableData);
    this.menuClose();
  }

  menuClose(): void {
    this.dbFilter.forEach(item => item.selected = false)
    const selectedFilters = this.dbFilterRecord.filter(item => item.selected === true).map(item => item.value);
    selectedFilters.forEach(filter => {
      this.dbFilter.find(item => item.value === filter).selected = true;
    })
  }

  searchBp(event): void {
    this.searchText = event.target.value;
    let filteredResults = this.backupResults.filter(item => item.to?.databaseName?.toLowerCase().includes(event.target.value.toLowerCase()) || item.to?.fileName?.toLowerCase().includes(event.target.value.toLowerCase()) || item.to?.serverName?.toLowerCase().includes(event.target.value.toLowerCase()) ||
    item.component?.toLowerCase().includes(event.target.value.toLowerCase()) || item.ticketNumber?.toLowerCase().includes(event.target.value.toLowerCase()));
    const selectedFilters = this.dbFilter.filter(item => item.selected === true).map(item => item.value);
    if (selectedFilters.length > 0) {
      filteredResults = filteredResults.filter(item => selectedFilters.includes(item.status) || selectedFilters.includes(''));
    }
    this.pageIndex = 0;
    const tableData = filteredResults?.slice(0, 0 + this.dbPaginationSize);
    this.backupTable = filteredResults;
    this.dataSourceDb = new MatTableDataSource(tableData);
  }

  getDatabases(): void  {
    this.showLoader = true;
    this.instanceService.getInstanceDatabases(this.instanceId)
    .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(response => {
         this.dbLoading = false;
        this.databases = response.databases;
        this.getInstanceBackupResults();
      },
      (error) => {
        this.apiNotFound = true;
        this.getInstanceBackupResults();
        setTimeout(() => {
          const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });

  }

   getInstanceBackupResults(): void {
    this.isBackupTableLoaded = false;
    this.dbBackupService.getInstanceDbBackups(this.instanceId)
    .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(results => {
        if (Number(results.total) > 10) {
          this.dbBackupService.getInstanceDbBackups(this.instanceId, results?.total)
          .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(response => {
              this.showLoader = false;
              this.processDbData(response);
            })
        } else {
          this.showLoader = false;
          this.processDbData(results);
        }
      },
      (error) => {
        this.showLoader = false;
        this.isBackupTableLoaded = true;
        setTimeout(() => {
          const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
  }

  processDbData(results): void {
    let sortedData;
    results.data = results?.data?.sort((a, b) => new Date(b?.createdAt).getTime() - new Date(a?.createdAt).getTime());
    sortedData = results?.data;
    sortedData?.forEach(item => {
      let createdAt = new Date(item.createdAt);
      let expirationDate = new Date(item.expirationDate);
      let days = Math.floor((Date.UTC(expirationDate.getFullYear(), expirationDate.getMonth(), expirationDate.getDate()) - Date.UTC(createdAt.getFullYear(), createdAt.getMonth(), createdAt.getDate()) ) /(1000 * 60 * 60 * 24));
      item.expiryDays = days;
      if (item.status === 'completed' && (new Date(item?.expirationDate).setHours(12, 0, 0, 0) - new Date().setHours(12, 0, 0, 0) < 0)) {
        item.isExpired = true;
      }
      item.typeTag = item.from?.type?.toLowerCase()?.includes('postgresql') ? 'PostgreSQL' : item.from?.type?.toLowerCase()?.includes('sql') ? 'MSSQL' : '';
      item.dbName = this.resolveDbName(item);
    })
    this.dbInprogess = sortedData?.find(item => item.status === 'inprogress');
    this.dbdata = sortedData;
    this.backupResults = this.dbdata;
    this.backupResults?.length > 0 ? this.envDBResponse=true: this.envDBResponse = false;
    this.backupTable = sortedData;
    this.isBackupTableLoaded = true;
    this.dataSourceDb = new MatTableDataSource(this.backupTable?.slice(0, 0 + this.dbPaginationSize));
    this.dbFilter = this.dbStatusFilter.concat(this.dbTypeFilter, this.dbNameFilter);
    this.dbFilterRecord = cloneDeep(this.dbFilter);
  }

  resolveDbName(element: any): string {
    return element?.backupType === 'archive' && element?.to?.fileName ? element?.to?.fileName 
    : element?.backupType === 'snapshot' && element?.from?.type.toLowerCase()?.includes('microsoft.sql') ? element?.to?.databaseName 
    : element?.backupType === 'snapshot' && element?.from?.type.toLowerCase()?.includes('postgresql') ? element?.to?.serverName 
    : element?.typeTag === '	' && element?.to?.serverName ? element?.to?.serverName 
    : 'N/A'
  }

  openDetails(element): void {
    if(element?.to?.serverName || element?.to?.fileName || element?.to?.databaseName){
    element.from.releaseVersion = element.to.releaseVersion = element?.configurationVersion;
    element.from.solutionVersion = element.to.solutionVersion = element?.solutionReleaseVersion;
    this.dialog.open(DbBackupDetailsComponent, {
      maxHeight: '99vh',
      width: '678px',
      panelClass: 'flex-dialog',
      data: element
    });
    }else{
        this.dialog.open(ErrorDialogComponent, {
        minHeight: '226px',
        width: '566px',
        panelClass: 'flex-dialog',
        data: {
          internalError: true,
          description: translate('INSTANCE_DETAILS.DATABASE_BACKUP_DETAILS_NOT_FOUND'),
        }
      });
    }

  }

  createNewBackup(): void {
    if (this.databases?.length === 0) {
      this.dialog.open(ErrorDialogComponent, {
        minHeight: '226px',
        width: '566px',
        panelClass: 'flex-dialog',
        data: {
          internalError: true,
          description: translate('INSTANCE_DETAILS.DATABASE_DETAILS_NOT_FOUND'),
          note: translate('INSTANCE_DETAILS.DATABASE_DETAILS_NOT_FOUND_NOTE_MSG'),
        }
      });
      return;
    }

    const data = {
      id: this.instanceId,
      subtitle: this.data?.name,
      databases: this.databases,
      instance: this.data,
      dbResults: this.backupResults
    };
    this.sidenavService.openInRightSidenav(DbBackupFormComponent, data)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(result => {
      if (result) {
        this.instanceService.triggerRefresh();
        this.getInstanceBackupResults();
      }
    })
  }

  menuItemClick(): void {
    setTimeout(() => {
      if (document.getElementsByClassName("cdk-overlay-container")) {
        const element = <HTMLElement> document.getElementsByClassName("cdk-overlay-container")[0];
        if (element) {
          element.style.display = 'block';
        }
      }
    }, 100);
  }

  ticketNumberClick(ticketNumber): void {
    const url = `https://itsm-servicedesk.temenos.com/browse/${ticketNumber}`;
    window.open(url, '_blank');
  }

  cancelStatusFilter(data) {
    let selectedItem = this.selectedStatus.indexOf(data);
    if (selectedItem > -1) {
      localStorage.removeItem('filteredDBStatus');
      this.selectedStatus.splice(selectedItem, 1);
      this.dbDropdownsList[0].options.find(item => item.value === data).selected = false;
      localStorage.setItem('filteredDBStatus', JSON.stringify(this.selectedStatus));
      this.filterDBItems(this.filteredColumns);
    }
  }

  cancelDBTypeFilter(data) {
    let selectedItem = this.selectedDBType.indexOf(data);
    if (selectedItem > -1) {
      localStorage.removeItem('filteredDBType');
      this.selectedDBType.splice(selectedItem, 1);
      this.dbDropdownsList[1].options.find(item => item.value === data).selected = false;
      localStorage.setItem('filteredDBType', JSON.stringify(this.selectedDBType));
      this.filterDBItems(this.filteredColumns);
    }
  }

    cancelDBNameFilter(data) {
    let selectedItem = this.selectedDBName.indexOf(data);
    if (selectedItem > -1) {
      localStorage.removeItem('filteredDBName');
      this.selectedDBName.splice(selectedItem, 1);
      this.dbDropdownsList[2].options.find(item => item.value === data).selected = false;
      localStorage.setItem('filteredDBName', JSON.stringify(this.selectedDBName));
      this.filterDBItems(this.filteredColumns);
    }
  }

    filterColumns(): void {
        if(this.dbStatus) {
          this.dbDropdownsList[0]?.options.filter((item) => {
            if (this.dbStatus?.find(status => status === item.value)) {
              item.selected = true;
            }
          });
        }
        if(this.dbType) {
          this.dbDropdownsList[1]?.options.filter((item) => {
            if (this.dbType?.find(status => status === item.value)) {
              item.selected = true;
            }
          });
        }
        if(this.dbName) {
          this.dbDropdownsList[2]?.options.filter((item) => {
            if (this.dbName?.find(version => version === item.value)) {
              item.selected = true;
            }
          });
        }

        const data = {
          name: translate('TENANT_DETAILS.DATABASE_BACKUP'),
          title: translate('INSTANCE_STATUS.FILTER_TITLE'),
          subtitle: translate('INSTANCE_STATUS.FILTER_SUBTITLE'),
          filteredColumns: this.dbDropdownsList,
          statusList: this.dbDropdownsList?.[0].options,
          dbTypeList: this.dbDropdownsList?.[1].options,
          dbNameList: this.dbDropdownsList?.[2].options,

          envdbDetailColumns: [
            'status',
            'dbType',
            'dbName',
          ]
        };
        this.sidenavService.openInRightSidenav(ColumnFilterComponent, data)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(filteredColumns => {
          this.filteredColumns = filteredColumns;
          if (filteredColumns) {
            this.isFiltered = true;
            this.clearData = true;
             if(filteredColumns[0] !== '') {
              this.dbStatus = filteredColumns[0];
            }
            if(filteredColumns[1] !== '') {
              this.dbType = filteredColumns[1];
            }
            if(filteredColumns[2] !== '') {
              this.dbName = filteredColumns[2];
            }


             if (filteredColumns[0]?.length === 0 && filteredColumns[1]?.length === 0 && filteredColumns[2]?.length === 0){
              this.resetJobFilter();
            } else {
              this.filterDBItems(filteredColumns);
            }
          }
        });
      }

         filterDBItems(filteredColumns): void {
            if (filteredColumns) {
              this.backupResults = this.dbdata;
              this.selectedStatus = [];
              this.selectedDBType = [];
              this.selectedDBName = [];
              if (filteredColumns[0]?.length > 0) {
                this.selectedStatus = filteredColumns[0];
                if (filteredColumns[0].length > 0) {
                  localStorage.setItem('filteredDBStatus', JSON.stringify(this.selectedStatus));
                  this.backupResults = this.backupResults?.filter(item => this.selectedStatus?.includes(item?.status));
                } else {
                  localStorage.removeItem('filteredDBStatus');
                }
              }
              if (filteredColumns[1]?.length > 0) {
                this.selectedDBType = filteredColumns[1];
                if (filteredColumns[1].length > 0) {
                  localStorage.setItem('filteredDBType', JSON.stringify(this.selectedDBType));
                  this.backupResults = this.backupResults?.filter(item => this.selectedDBType?.includes(item?.backupType));
                } else {
                  localStorage.removeItem('filteredDBType');
                }
              }
              if (filteredColumns[2]?.length > 0) {
                this.selectedDBName = filteredColumns[2];
                if (filteredColumns[2]?.length > 0) {
                  localStorage.setItem('filteredDBName', JSON.stringify(this.selectedDBName));
                  this.backupResults = this.backupResults?.filter(item => this.selectedDBName?.includes(item?.backupInterval));
                } else {
                  localStorage.removeItem('filteredDBName');
                }
              }


            }
          }

  /* Reset the selected job filter */
  resetJobFilter(): void {
    this.isFiltered = false;
    this.selectedStatus = [];
    this.selectedDBType = [];
    this.selectedDBName = [];
    this.sidenavService.searchFilter.next('dataJobs');
    this.dbDropdownsList?.[0]?.options?.filter((item) => {item.selected = false});
    this.dbDropdownsList?.[1]?.options.filter((item) => {item.selected = false});
    this.dbDropdownsList?.[2]?.options?.filter((item) => {item.selected = false});
    this.dbDropdownsList?.[3]?.options?.filter((item) => {item.selected = false});
    this.status = undefined;
    this.dbType = undefined;
    this.dbName = undefined;
    this.dbStatus = undefined;
    this.backupResults = this.dbdata;
    localStorage.setItem('clearJobFilter',"true");

    localStorage.removeItem('filteredDBType');
    localStorage.removeItem('filteredDBName');
    localStorage.removeItem('filteredDBStatus');
  }

  getDBTypeLabel(dbType): void {
    return this.selectedDBType?.find(item => item.value === dbType)?.label || dbType || '';

  }

  getDBNameLabel(dbName): void {
        return this.dbNameFilter?.find(item => item.value === dbName)?.name || dbName || '';

  }

  getStatusLabel(status): void {
            return this.selectedStatus?.find(item => item.value === status)?.label || status || '';

  }

}


